import React from 'react';
import { compose, pure } from 'recompose';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CheckOkButton from '../atoms/CheckOkButton';
import CheckNgButton from '../atoms/CheckNgButton';
import CheckInvalidButton from '../atoms/CheckInvalidButton';
import ShopUnRelationTextButton from '../atoms/ShopUnRelationTextButton';

const styles = {
  textGroup: {
    whiteSpace: 'pre-wrap'
  }
};

const enhance = compose(pure);

const ReleaseTableBody = enhance(
  ({
    shops,
    classes,
    page,
    rowsPerPage,
    shopRedirectAction,
    menuRedirectAction,
    identityAction,
    shopUnRelationAction,
    order,
    orderBy
  }) => {
    const sortedResult = _.orderBy(shops, orderBy, order);
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(shop => {
            const isIdentityConfirmed = shop.accountStatus.identity;
            const isIdentityRegistered =
              !shop.accountStatus.identity &&
              shop.accountStatus.identityRegistered;
            const isIdentityRegister =
              !shop.accountStatus.identity &&
              !shop.accountStatus.identityRegistered &&
              shop.accountStatus.identityRegisterable;
            const isStripeRegister =
              !shop.accountStatus.identity &&
              !shop.accountStatus.identityRegistered &&
              !shop.accountStatus.identityRegisterable;

            const onClickParams = {
              shopId: shop.shopId,
              shopName: shop.shopName,
              stripeUseSwitchable: shop.stripeUseSwitchable
            };
            return (
              <TableRow key={shop.shopId}>
                <TableCell>{shop.shopId}</TableCell>
                <TableCell>{shop.shopName}</TableCell>
                <TableCell>
                  {shop.accountStatus.shop && (
                    <CheckOkButton
                      id={shop.shopId}
                      onClickAction={shopRedirectAction}
                    />
                  )}
                  {!shop.accountStatus.shop && (
                    <CheckNgButton
                      id={shop.shopId}
                      onClickAction={shopRedirectAction}
                    />
                  )}
                </TableCell>
                <TableCell>
                  {shop.accountStatus.menu && (
                    <CheckOkButton
                      id={shop.shopId}
                      onClickAction={menuRedirectAction}
                    />
                  )}
                  {!shop.accountStatus.menu && (
                    <CheckNgButton
                      id={shop.shopId}
                      onClickAction={menuRedirectAction}
                    />
                  )}
                </TableCell>
                <TableCell>
                  {/* 本人確認登録済み＋確認済みの場合 */}
                  {isIdentityConfirmed && (
                    <CheckOkButton
                      onClickAction={
                        identityAction.identityConfirmedAlertAction
                      }
                    />
                  )}
                  {/* 本人確認登録済み＋未確認の場合 */}
                  {isIdentityRegistered && (
                    <CheckNgButton
                      onClickAction={
                        identityAction.identityRegisteredAlertAction
                      }
                    />
                  )}
                  {/* 本人確認未登録＋Stripe登録済み(もしくは入金管理がNONSELF)の場合 */}
                  {isIdentityRegister && (
                    <CheckNgButton
                      id={shop.shopId}
                      onClickAction={identityAction.identiryRegisterOpenAction}
                    />
                  )}
                  {/* 本人確認未登録＋Stripe未登録の場合 */}
                  {isStripeRegister && (
                    <CheckNgButton
                      id={shop.shopId}
                      onClickAction={identityAction.identiryRegisterOpenAction}
                    />
                  )}
                </TableCell>
                <TableCell>
                  {shop.paymentGroupType === 'STRIPE' ? (
                    <>
                      {shop.paymentGroupAccount ? (
                        <>
                          <CheckOkButton />
                          {shop.paymentGroupName && (
                            <div className={classes.textGroup}>
                              {`(${shop.paymentGroupName})`}
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          <CheckNgButton />
                          {shop.paymentGroupName && (
                            <div className={classes.textGroup}>
                              {`(${shop.paymentGroupName})`}
                            </div>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {shop.depositManage === 'SELF' &&
                        shop.accountStatus.stripeAccount && <CheckOkButton />}
                      {shop.depositManage === 'SELF' &&
                        !shop.accountStatus.stripeAccount && <CheckNgButton />}
                      {shop.depositManage !== 'SELF' && <CheckInvalidButton />}
                    </>
                  )}
                </TableCell>
                <TableCell>
                  {shop.paymentGroupType === 'BANK' ? (
                    <>
                      {shop.paymentGroupAccount ? (
                        <>
                          <CheckOkButton />
                          {shop.paymentGroupName && (
                            <div className={classes.textGroup}>
                              {`(${shop.paymentGroupName})`}
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          <CheckNgButton />
                          {shop.paymentGroupName && (
                            <div className={classes.textGroup}>
                              {`(${shop.paymentGroupName})`}
                            </div>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {shop.depositManage === 'NONSELF' && <CheckOkButton />}
                      {shop.depositManage !== 'NONSELF' && (
                        <CheckInvalidButton />
                      )}
                    </>
                  )}
                </TableCell>
                <TableCell>
                  <ShopUnRelationTextButton
                    onClickAction={shopUnRelationAction}
                    onClickParams={onClickParams}
                  />
                </TableCell>
              </TableRow>
            );
          })}
      </TableBody>
    );
  }
);

export default withStyles(styles)(ReleaseTableBody);
